document.addEventListener('DOMContentLoaded', function() {
  const scrollTarget = document.querySelectorAll('[data-scroll-to]');
  scrollTarget.forEach(function(e) {
    e.addEventListener('click', function() {
      const target = e.getAttribute('data-scroll-to');
      const targetSection = document.getElementById(target);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
  let currentE = null;
  function handleScroll() {
    let scrollPosition = window.scrollY || window.pageYOffset;
    document.querySelectorAll('.sidebar').forEach(function (e) {
      let eTop = e.offsetTop;
      if (scrollPosition >= eTop) {
        if (e !== currentE) {
          if (currentE) {
            currentE.classList.remove('underline');
          }
          let target =  document.querySelector(`[data-scroll-to="${e.id}"]`);
          target.classList.add('underline');
          currentE = target;
        }
      }
    });
  }
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});
